import { render, staticRenderFns } from "./DoYouReallyWant.vue?vue&type=template&id=60564c0b&scoped=true"
import script from "./DoYouReallyWant.vue?vue&type=script&lang=js"
export * from "./DoYouReallyWant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60564c0b",
  null
  
)

export default component.exports